module.exports = __webpack_public_path__ + "static/media/show.b349311c.png";